import { render, staticRenderFns } from "./UploadUserPhotoModal.vue?vue&type=template&id=3a1a6476&scoped=true&"
import script from "./UploadUserPhotoModal.vue?vue&type=script&lang=js&"
export * from "./UploadUserPhotoModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadUserPhotoModal.vue?vue&type=style&index=0&id=3a1a6476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a6476",
  null
  
)

export default component.exports